import type { ReactElement, ReactNode } from 'react';
import { ButtonRow } from '@ksyos/design-system';
import type { Button, IconButton, Link } from '../common';
import { ProcessStartWizardCol } from './ProcessStartWizardCol';
import { ProcessStartWizardRow } from './ProcessStartWizardRow';

interface IProcessStartWizardButtonRowProps {
    actionComponent?: ReactElement<typeof Button | typeof Link | typeof IconButton>;
    children: ReactNode;
    header?: boolean;
    label?: string;
    result?: boolean;
}

export function ProcessStartWizardButtonRow(props: IProcessStartWizardButtonRowProps) {
    return (
        <ProcessStartWizardRow
            actionComponent={props.actionComponent}
            header={props.header}
            label={props.label}
            result={props.result}
        >
            <ProcessStartWizardCol>
                <ButtonRow>{props.children}</ButtonRow>
            </ProcessStartWizardCol>
        </ProcessStartWizardRow>
    );
}
